import { Api, ApiResponse } from "../_base";
import moment from "moment-timezone";

export * from "./review";

export function loadPlaybookInsights(
  playbookId: string | number,
  query: Record<string, any> = {}
): Promise<ApiResponse<any>> {
  query.tz = moment().utcOffset();
  return Api.execute({
    url: `/api/insights/${playbookId}/summary`,
    params: query,
  });
}

export function loadClauseInsights(
  playbookId: string | number,
  clauseId: string | number,
  query: Record<string, any> = {}
): Promise<ApiResponse<any>> {
  query.tz = moment().utcOffset();
  return Api.execute({
    url: `/api/insights/${playbookId}/clauses/${clauseId}/summary`,
    params: query,
  });
}
